import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { forwardRef } from "react";
import AnimatedNumber from "../../../../../../base/text/animated-number/index.js";
import { SearcherNumber, SearcherNumberText } from "../../../styled.js";
import * as S from "./styled.js";
const SearcherButtonDesktop = /*#__PURE__*/ forwardRef(({ disabled =false , counter , counterText , showCount =true , underButton , grow =false , order , height , variant ='adaptive' , children , onClick , className ='' , buttonVariant ='primary'  }, ref)=>/*#__PURE__*/ _jsxs(S.SearcherItemButtonDesktop, {
        "data-testid": "SearcherButtonDesktop",
        className: classNames('searcher-button', {
            [className]: !!className
        }),
        $variant: variant,
        $grow: grow,
        $order: order,
        children: [
            counter !== undefined && showCount && /*#__PURE__*/ _jsxs(S.NumberTextWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(SearcherNumber, {
                        "data-testid": "SearcherNumber",
                        children: /*#__PURE__*/ _jsx(AnimatedNumber, {
                            number: counter
                        })
                    }),
                    /*#__PURE__*/ _jsx(SearcherNumberText, {
                        "data-testid": "SearcherNumberText",
                        children: counterText
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(S.SearcherWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(S.SearcherWrapperButton, {
                        type: "submit",
                        variant: buttonVariant,
                        ref: ref,
                        disabled: disabled,
                        "data-testid": "SearcherButton",
                        height: height,
                        onClick: onClick,
                        children: children
                    }),
                    underButton
                ]
            })
        ]
    }));
SearcherButtonDesktop.displayName = 'SearcherButtonDesktop';
export default SearcherButtonDesktop;

//# sourceMappingURL=index.js.map